// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".HyperlinkOverlay__LinkRect___1NK7H{border:1px solid LinkText}", ""]);
// Exports
exports.locals = {
	"LinkRect": "HyperlinkOverlay__LinkRect___1NK7H"
};
module.exports = exports;
